import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SimpleAccordionComponent } from './simple-accordion.component';

@NgModule({
  declarations: [ SimpleAccordionComponent ],
  exports: [ SimpleAccordionComponent ],
  imports: [ CommonModule ]
})
export class SimpleAccordionModule { }
